module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('span', {
      class: 'num-' + item
    }, [_vm._v(_vm._s(item === 'n' ? '' : (item === 'd' || item === 'd_c' ? ':' : item)))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636f67b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/number/index.vue
// module id = 174
// module chunks = 1